import PropTypes from 'prop-types';
import Iconify from 'src/components/Iconify';

// Mostrado no lugar de um select cujo cadastro ainda está vazio. Sem isso o
// usuário abria a lista, não achava nada e ficava sem saída — não há como
// descobrir, a partir do card do negócio, onde a opção é cadastrada.
//
// Abre em nova aba de propósito: cadastrar a opção não deve custar o contexto do
// negócio (o modal é desmontado ao trocar de rota). O usuário cadastra na outra
// aba, volta e reabre o negócio para a lista vir preenchida.
export default function SemOpcoesCta({ label, href }) {
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-9 w-full items-center gap-2 rounded-lg border border-dashed border-gray-300 px-3 text-sm text-gray-500 transition-colors hover:border-[#7C3AED]/50 hover:bg-violet-50/50 hover:text-[#7C3AED] dark:border-[#383838] dark:text-[#8b8d90] dark:hover:border-[#7C3AED]/50 dark:hover:bg-violet-500/5"
        >
            <Iconify icon="eva:plus-outline" width={14} className="shrink-0" />
            <span className="truncate">{label}</span>
            <Iconify icon="eva:external-link-outline" width={13} className="ml-auto shrink-0 opacity-60" />
        </a>
    );
}

SemOpcoesCta.propTypes = {
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
};
